import { KeyboardEvent } from 'react'

export const isSubmitShortcut = (event: KeyboardEvent) => {
  return event.key === 'Enter' && (event.metaKey || event.ctrlKey)
}
